import { events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";

const initialState: State = {
  isFailure: false,
  isPending: false,
  isSuccessful: false,
};

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.addEveryoneToProjectRequested]: setRequestStateToPending,
    [events.addEveryoneToProjectSucceeded]: setRequestStateToSuccess,
    [events.addEveryoneToProjectFailed]: setRequestStateToFailure,
  }),
  [events.changePlanzoneSucceeded],
);

function createSelector(getState: () => State): Selector {
  return {
    isAddEveryoneToProjectRequestFailure() {
      return getState().isFailure;
    },
    isAddEveryoneToProjectRequestPending() {
      return getState().isPending;
    },
    isAddEveryoneToProjectRequestSuccess() {
      return getState().isSuccessful;
    },
  };
}

export type { State, Selector };

export { reduceState, initialState, createSelector };
